module.exports = __webpack_public_path__ + "img/tips_01.c415e55f.png";